/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useContext, useEffect, useState } from "react";
import forEmptyResult from "@/assets/Images/forEmptyResult.webp";
import NewsCard from "@/elements/NewsCard/NewsCard";
import { useGetAxios } from "@/hooks/useGetAxios";
import EventCard from "@/elements/EventCard/EventCard";
import Image from "next/image";
import InfoIcon from "@/assets/icn/info.png";

import moment from "moment";
import { CardTitleBtn } from "@/elements/Button/Button";
import { ModalProvider } from "@/contexts/StockPageModal";
import { Button } from "@/components/ui/button";
import { Mixpanel } from "@/elements/Mixpanel";

const modalData = [
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    },
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    },
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    },
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    },
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    },
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    },
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    },
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    },
    {
        heading: "Bonus",
        details: `Bonus is a bonus offered by a company to its employees who are hired after the company's initial public offering (IPO)`
    }
];
function NewsAndEvents({ name, symbol }) {
    const modal = useContext(ModalProvider);
    const [eventType, setEventType] = useState("All");

    const { data: dataNews, loading, fetchData: fetchDataNews } = useGetAxios();
    const { data: dataEvents, fetchData: fetchDataEvents } = useGetAxios();

    useEffect(() => {
        fetchDataNews(`/resources/stock-details/news?fin-code=${name}`);
        fetchDataEvents(`/resources/stock-details/v2/corporate-actions?fin-code=${name}`);
    }, [name]);

    const filterEvents = (data) => {
        let elements = data.filter((element) => {
            return element.category?.toLowerCase() === eventType?.toLowerCase() || eventType === "All";
        });
        let events;

        if (elements?.length === 0) {
            events = (
                <div className="pt-10 lg:pt-20 col-span-2">
                    <Image src={forEmptyResult} alt="icon" className="mx-auto" width={250} />
                    <div className="text-center font-Inter text-[16px] landing-[28px] text-black font-semibold mt-3">
                        Nothing to show for now
                    </div>
                    <div className="text-center font-Inter text-[12px] landing-[18px] text-[#414141] mt-2">
                        Don’t worry we’l keep you posted
                    </div>
                </div>
            );
        } else {
            events = elements?.map((element, i) => (
                <>
                    <EventCard
                        data={element}
                        name={name}
                        key={i}
                        symbol={symbol}
                        onClick={(data) => {
                            modal.setTitle("More information");
                            modal.setModalData(
                                <div className="p-4">
                                    <div className="border border-[#ECF6FE] rounded-lg overflow-hidden">
                                        <div className="bg-[#ECF6FE] px-3 py-2 text-sm font-bold text-[#202020]">
                                            {element.detailedBF?.header}
                                        </div>
                                        <div className="w-full grid grid-cols-1 px-3 border-b">
                                            {element.detailedBF?.details?.map((ele, i) => (
                                                <div
                                                    className="text-xs text-[#606060] font-medium py-3"
                                                    key={ele?.label}
                                                >
                                                    {ele?.label} :<br />
                                                    <b className="text-black">{ele?.value}</b>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <Button
                                        onClick={() => {
                                            modal.setModal(false);
                                            Mixpanel.track("cta_clicked", {
                                                page: "event_more_info_bf",
                                                cta_text: "alright"
                                            });
                                        }}
                                        className="w-full"
                                    >
                                        Alright!
                                    </Button>
                                </div>
                            );
                            modal.setModal(true);
                        }}
                    />
                </>
            ));
        }

        return events;
    };
    const openModalHandler = () => {
        modal.setTitle("What are events?");
        modal.setModalData(modalData);
        modal.setModal(true);
    };
    return (
        <div className="">
            {loading ? (
                <div />
            ) : (
                <>
                    {dataNews?.length > 0 && (
                        <div className="font-Inter bg-gradient-to-b from-[#FFF2D8] to-white ">
                            <div className="text-black text-base font-semibold p-4">Latest news</div>
                            <div className=" flex flex-row overflow-x-auto no-scrollbar swiper-no-swiping gap-4 px-4 pb-2">
                                {dataNews?.map((ele, i) => (
                                    <NewsCard data={ele} name={name} key={i} />
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="flex flex-col gap-4 p-4">
                        <div className="text-black text-base font-semibold flex gap-2">
                            Events
                            <Image
                                src={InfoIcon}
                                alt="info"
                                className="w-[14px] h-[14px] self-center bg-white"
                                onClick={() => {
                                    openModalHandler();
                                    Mixpanel.track("info_clicked", {
                                        page: "stock_page_web",
                                        tab: "news_events",
                                        info_type: "events_meaning",
                                        symbol: symbol
                                    });
                                }}
                            />
                        </div>
                        <div className="font-Inter text-xs flex flex-row justify-start overflow-x-auto no-scrollbar swiper-no-swiping snap-x snap-mandatory gap-y-3 gap-x-4">
                            {["All", "Dividends", "Announcements", "Bonus", "Rights", "Splits", "Others"]
                                //  ["All", ...new Set(dataEvents?.map((ele) => ele.category))]
                                .map((ele, i) => (
                                    <CardTitleBtn
                                        active={eventType === ele}
                                        text={ele}
                                        onClick={() => {
                                            setEventType(ele);
                                            Mixpanel.track("chip_clicked", {
                                                page: "stock_page_web",
                                                tab: "news_events",
                                                chip_text: ele,
                                                symbol: symbol
                                            });
                                        }}
                                        key={i}
                                    />
                                ))}
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">{filterEvents(dataEvents)}</div>
                    </div>
                </>
            )}
        </div>
    );
}

export default memo(NewsAndEvents);
